import styled from 'styled-components';

export const Container = styled.div`
  background-color: #000;
  height: 100vh;
  position: relative;

  h2 {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
  }

  .btn-manual {
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    height: 40px;
  }

  .btn-back {
    top: 10px;
    right: 10px;
    position: absolute;
    font-size: 25px;
    z-index: 1000;

    svg {
      fill: #fff;
      width: 25px;
      height: 25px;
    }
  }

  .scanner {
    width: 100%;
    height: 100vh;

    > div {
      width: 100%;
      height: 100vh;
      padding: 0 !important;
    }
  }

  .collector-input {
    position: absolute;
    top: -9999px;
    left: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
    border: none;
    outline: none;
    background: transparent;
    color: transparent;
    caret-color: transparent;
    resize: none;
  }

  &.collector-mode {
    background: radial-gradient(
      circle at top,
      #1f2a44 0%,
      #0b1020 60%,
      #050810 100%
    );
    overflow: hidden;
  }

  .collector-screen {
    position: relative;
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 70px 20px 130px;
    color: #fff;
  }

  .collector-header {
    text-align: center;
    margin-bottom: 30px;

    .event-label {
      display: inline-block;
      text-transform: uppercase;
      letter-spacing: 3px;
      font-size: 11px;
      color: #ff6900;
      font-weight: 700;
      margin-bottom: 6px;
    }

    h1 {
      font-size: 22px;
      font-weight: 700;
      margin: 0;
      color: #fff;
    }
  }

  .collector-radar {
    position: relative;
    width: 220px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0 20px;

    .radar-ring {
      position: absolute;
      border-radius: 50%;
      border: 2px solid rgba(255, 105, 0, 0.4);
      animation: collector-pulse 2.4s infinite ease-out;
    }
    .ring-1 {
      width: 100%;
      height: 100%;
      animation-delay: 0s;
    }
    .ring-2 {
      width: 75%;
      height: 75%;
      animation-delay: 0.4s;
    }
    .ring-3 {
      width: 50%;
      height: 50%;
      animation-delay: 0.8s;
    }

    .radar-core {
      position: relative;
      z-index: 2;
      width: 110px;
      height: 110px;
      border-radius: 50%;
      background: linear-gradient(135deg, #ff6900 0%, #ff9248 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 30px rgba(255, 105, 0, 0.45);
      transition: background 0.3s ease, box-shadow 0.3s ease;

      svg {
        width: 50px;
        height: 50px;
        fill: #fff;
      }
    }

    &.pulse-success .radar-core {
      background: linear-gradient(135deg, #198754 0%, #4caf50 100%);
      box-shadow: 0 8px 40px rgba(25, 135, 84, 0.6);
    }
    &.pulse-error .radar-core {
      background: linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%);
      box-shadow: 0 8px 40px rgba(220, 53, 69, 0.6);
    }
  }

  @keyframes collector-pulse {
    0% {
      transform: scale(0.85);
      opacity: 0.9;
    }
    100% {
      transform: scale(1.15);
      opacity: 0;
    }
  }

  .collector-status {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.06);
    padding: 6px 14px;
    border-radius: 999px;
    font-size: 13px;
    color: #cbd5e1;
    margin-bottom: 18px;

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #22c55e;
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
      animation: dot-pulse 1.5s infinite;
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
    }
    70% {
      box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    }
  }

  .collector-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 22px;

    .value {
      font-size: 56px;
      font-weight: 800;
      line-height: 1;
      color: #fff;
      letter-spacing: -2px;
    }
    .caption {
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: #94a3b8;
      margin-top: 4px;
    }
  }

  .collector-last-card {
    width: 100%;
    max-width: 420px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    border-radius: 14px;
    padding: 16px 18px;

    .last-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: #94a3b8;
      margin-bottom: 10px;

      svg {
        width: 16px;
        height: 16px;
        fill: #94a3b8;
      }
    }

    .last-name {
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      margin-bottom: 10px;
      word-break: break-word;
    }

    .last-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-bottom: 10px;

      .tag {
        background: rgba(255, 105, 0, 0.18);
        color: #ff9248;
        font-size: 12px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 999px;
        border: 1px solid rgba(255, 105, 0, 0.35);

        &.tag-secondary {
          background: rgba(99, 102, 241, 0.15);
          color: #a5b4fc;
          border-color: rgba(99, 102, 241, 0.35);
        }
      }
    }

    .last-kit {
      list-style: none;
      padding: 10px 0 0;
      margin: 0;
      border-top: 1px solid rgba(255, 255, 255, 0.08);

      li {
        font-size: 13px;
        color: #cbd5e1;
        padding: 3px 0;

        b {
          color: #fff;
          text-transform: capitalize;
          margin-right: 4px;
        }
      }
    }
  }

  .square {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;

    > div {
      display: flex;
      flex-direction: column;

      div {
        width: 150px;
        height: 5px;
        background-color: #ff6900;

        :nth-child(2) {
          width: 5px;
          height: 400px;
          background: #ff6900;
          background: linear-gradient(
            180deg,
            rgba(255, 105, 0, 1) 0%,
            rgba(255, 105, 0, 1) 25%,
            rgba(255, 105, 0, 0) 25%,
            rgba(255, 105, 0, 0) 75%,
            rgba(255, 105, 0, 1) 75%,
            rgba(255, 105, 0, 1) 100%
          );
        }
      }

      + div {
        margin-left: 75px;
      }
    }

    .right {
      align-items: flex-end;
    }
  }
`;
